export const SBER_BANK_LABEL = '_sber';

export const TINKOFF_BANK_LABEL = '_tinkoff';
